import React, { useState } from 'react';
import { deleteArtWorksById } from "../../Api/apiUrls";

const Delete_Art_Work = ({ artwork, onClose, onArtworkDeleted }) => {
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async () => {
    if (!window.confirm('Are you sure you want to delete this artwork? This action cannot be undone.')) {
      return;
    }

    setIsDeleting(true);

    try {
      const response = await fetch(`${deleteArtWorksById}${artwork.id}`, {
        method: "DELETE",
        headers: {
          accept: "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to delete artwork");
      }

      const data = await response.json();
      
      if (data.success) {
        alert("Artwork deleted successfully!");
        if (onArtworkDeleted) onArtworkDeleted();
        onClose();
      } else {
        alert(data.message || "Failed to delete artwork");
      }
    } catch (error) {
      console.error("Error deleting artwork:", error);
      alert("Error deleting artwork. Please try again.");
    } finally {
      setIsDeleting(false);
    }
  };

  const handleClick = (e) => {
    if (e.currentTarget === e.target) {
      onClose();
    }
  };

  return (
    <div className="popup-background" onClick={handleClick}>
      <div className="popup" style={{ maxWidth: "500px" }}>
        <div className="modal-content">
          <div className="modal-header bg-danger text-white">
            <h5 className="modal-title">
              <i className="bi bi-exclamation-triangle me-2"></i>
              Delete Artwork
            </h5>
            <button type="button" className="close text-white" onClick={onClose}>
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          
          <div className="modal-body">
            <div className="alert alert-danger" role="alert">
              <h6 className="alert-heading">Warning!</h6>
              <p className="mb-0">
                Are you sure you want to delete the artwork "<strong>{artwork.name}</strong>"? 
                This action cannot be undone. All related data will be permanently removed.
              </p>
            </div>
            
            <div className="text-center my-4">
              <i className="bi bi-trash3 display-1 text-danger"></i>
            </div>
            
            <div className="text-center">
              {artwork.image && (
                <img
                  src={artwork.image}
                  alt={artwork.name}
                  style={{
                    width: "100px",
                    height: "100px",
                    objectFit: "cover",
                    borderRadius: "5px",
                    border: "1px solid #ddd"
                  }}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "https://via.placeholder.com/100x100?text=No+Image";
                  }}
                />
              )}
              <h6 className="mt-2">{artwork.name}</h6>
              <p className="text-muted mb-0">Rate: ₹{artwork.price} | Sequence: {artwork.sequence}</p>
            </div>
          </div>
          
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
              disabled={isDeleting}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={handleDelete}
              disabled={isDeleting}
            >
              {isDeleting ? (
                <>
                  <span className="spinner-border spinner-border-sm me-1" role="status"></span>
                  Deleting...
                </>
              ) : (
                'Delete Permanently'
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Delete_Art_Work;